import EquipmentView from './presentation/EquipmentView'
import FieldEngineerView from './presentation/FieldEngineerView'
import MapView from './presentation/MapView'
import { userWiseRole } from '../../utils/constant'

const { contractor, dealer, fieldEngineer } = userWiseRole

const filterByTypes = {
  equipment: 'txt_Equipment',
  fieldEngineer: 'user_Technician',
}

const getCurrentAddressType = {
  txt_Country: 'COUNTRY',
  user_State: 'STATE',
  user_City: 'CITY',
  user_Pincode: 'PINCODE',
  user_Building: 'BUILDING',
  txt_Equipment: 'EQUIPMENT',
}

const tabList = [
  {
    label: 'txt_ListView',
    key: 'txt_ListView',
    subTabList: [
      {
        label: 'txt_Equipment',
        Component: EquipmentView,
        key: 'viewListEquipment',
        filterByType: filterByTypes.equipment,
      },
      {
        label: 'user_Technician',
        Component: FieldEngineerView,
        key: 'viewListFieldEngineers',
        filterByType: filterByTypes.fieldEngineer,
      },
    ],
  },
  {
    label: 'txt_MapView',
    key: 'mapView',
    subTabList: [
      {
        label: 'txt_Equipment',
        Component: MapView,
        key: 'mapEquipment',
        filterByType: filterByTypes.equipment,
      },
    ],
  },
]

const equipmentFilterByOptions = t => [
  { value: 'equipment_manufacture', label: t('txt_EquipmentManufacturer') },
  { value: 'dealer', label: t('user_Dealer') },
  { value: 'customer', label: t('user_Customer') },
  { value: 'contractor', label: t('user_Contractor') },
]
const feFilterByOptions = t => [
  { value: 'equipment_manufacture', label: t('txt_EquipmentManufacturer') },
  { value: 'customer', label: t('user_Customer') },
]

const equipmentInitial = {
  txt_Country: {
    selected: null,
    search: '',
    list: [],
    filtered: [],
  },
  user_State: { selected: null, search: '', list: [], filtered: [] },
  user_City: { selected: null, search: '', list: [], filtered: [] },
  user_Pincode: { selected: null, search: '', list: [], filtered: [] },
  user_Building: { selected: null, search: '', list: [], filtered: [] },
  txt_Equipment: { selected: null, search: '', list: [], filtered: [] },
}

const feInitial = {
  user_Dealer: {
    selected: null,
    search: '',
    list: [],
    filtered: [],
  },
  user_Contractor: { selected: null, search: '', list: [], filtered: [] },
  user_Technician: { selected: null, search: '', list: [], filtered: [] },
}

const userLabelRoleId = {
  user_Dealer: dealer,
  user_Contractor: contractor,
  user_Technician: fieldEngineer,
}

export {
  filterByTypes,
  tabList,
  equipmentFilterByOptions,
  feFilterByOptions,
  equipmentInitial,
  feInitial,
  getCurrentAddressType,
  userLabelRoleId,
}
